import { useEffect } from 'react';

/** ResizeObserver не видит перемещение цели при transform-анимации родителя. */
export function useTourTargetTracking(target?: string, spotlightTarget?: string): void {
    useEffect(() => {
        if (!target) return;

        let frame: number;
        let previous = '';
        let lastCheck = -Infinity;
        const update = (timestamp: number) => {
            frame = requestAnimationFrame(update);
            // Не рассылаем глобальный resize на каждом кадре анимации.
            if (timestamp - lastCheck < 120) return;
            lastCheck = timestamp;
            const rects = [target, spotlightTarget].map((selector) => {
                if (!selector) return '';
                let element: Element | null;
                try {
                    element = document.querySelector(selector);
                } catch {
                    return '';
                }
                if (!element) return '';
                const { x, y, width, height } = element.getBoundingClientRect();
                return [x, y, width, height].join(',');
            }).join('|');

            if (rects !== previous) {
                previous = rects;
                // Joyride пересчитывает spotlight на resize, включая отложенно появившиеся цели.
                window.dispatchEvent(new Event('resize'));
            }
        };

        frame = requestAnimationFrame(update);
        return () => cancelAnimationFrame(frame);
    }, [target, spotlightTarget]);
}
